export const state = {
  myDriveRootIdString: null,
  driveTypeMap: {}, // { driveId: "", type: "OneDrive" },

  templateMap: {}
};
